import { Breadcrumb } from "@components/anti/Breadcrumb"
import { Cover } from "@components/anti/Cover"
import { Image, RatioImage } from "@components/anti/Image"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact, imgUrl } from "src/mixins"

import bg from "@public/img/bg/img_bg-home-mobile.jpg"
import bgDesktop from "@public/img/bg/img_bg-home.jpg"
import { translations } from "src/helper/translations"

function CareerLandingCover({ data, locale }) {
  const [trigger, anim] = useScrollAnim()

  return (
    <section className="sc-career-landing-cover">
      <Cover
        title={translations[`career_${locale}`]}
        text=""
        breadcrumb={
          <Breadcrumb
            path={`/${translations[`career_${locale}`]}`}
            theme="dark"
          />
        }
        imgHeight="h-400px"
        img={bg.src}
        imgMd={bgDesktop.src}
      />
      <div className="container py-main" ref={trigger}>
        <div className="row row-5">
          <div className="col-md-7 col-img">
            <RatioImage
              ratio="r-16-9"
              ratioClassName="mb-3"
              src={imgUrl(data?.banner_image_mobile)}
              alt="img-career"
              className={`img-fluid d-block d-md-none ${anim(3)}`}
            />
            <Image
              src={imgUrl(data?.banner_image_desktop)}
              alt="img-career"
              className={`img-fluid d-none d-md-block ${anim(3)}`}
              fill
            />
          </div>
          <div className="col-md-5 col-text">
            <h2 className={`title ${anim(1)}`}>
              {data && data[`title_${locale}`]}
            </h2>
            <div className={`text ${anim(2)}`}>
              {convertHtmlToReact(data[`description_${locale}`])}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CareerLandingCover
